import OccupancyOffActive from "src/ui/icons/occupancy-detection-off-active.svg"
import OccupancyOffOutlined from "src/ui/icons/occupancy-detection-off-outlined.svg"
import OccopancyOnActive from "src/ui/icons/occupancy-detection-on-active.svg"
import OccupancyOnOutlined from "src/ui/icons/occupancy-detection-outlined.svg"

/**
 * MotionAutomationToggleIcon
 * Toggle icon for motion automation (on/off states), using SecurityAlarm icons.
 * - 'on' + 'enabled': SecurityAlarmOnIcon
 * - 'on' + not 'enabled': SecurityAlarmOffIcon
 * - 'off' + 'enabled': SecurityAlarmOffIcon
 * - 'off' + not 'enabled': SecurityAlarmOnIcon
 * @example <MotionAutomationToggleIcon toggleState="on" state="enabled" />
 */
export function MotionAutomationToggleIcon({
  toggleState,
  state,
}: {
  toggleState: "on" | "off"
  state: "enabled" | "disabled"
}) {
  if (toggleState === "on") {
    if (state === "enabled") {
      return <OccopancyOnActive height="56" />
    }
    return <OccupancyOnOutlined height="56" />
  }
  // toggleState === 'off'
  if (state === "disabled") {
    return <OccupancyOffActive height="56" />
  }
  return <OccupancyOffOutlined height="56" />
}
